module.exports = __webpack_public_path__ + "img/16581296_L.587194d6.png";